import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormTerritorialArea } from './list/types';

export const initialValuesTerritorialAreas: FiltersFormTerritorialArea = {
  streetName: null,
  streetCode: '',
  civicNumberFrom: '',
  exponentFrom: '',
  civicNumberTo: '',
  exponentTo: '',
  civicType: 'all',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageTerritorialAreasInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesTerritorialAreas}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageTerritorialAreasInitializer.displayName = 'Page territorial areas initializer component';

export default PageTerritorialAreasInitializer;
